import React, { useContext, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Tools from "./JNSTools";
import { CredsContext } from "./Contexts";
import GanttChartComponent from "./GanttChartComponent_dialog";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import GlobalData from "./GlobalData";

function GanttChartContainer() {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const [wait, setWait] = useState(false);
  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);
  const [taskArray, setTaskArray] = useState([]);
  const resourceArray = useRef([]);
  //const userFullName = useRef();
  const [refreshFlag, setRefreshFlag] = useState(false);
  const changeArray = useRef([]);

  const BOOKING_TYPE_FOR_NEW_BOOKINGS = 6; //TODO: update this to dynamic find

  // retrieve oadaSettings from localStorage
  let oadaSettings;
  const settingsRaw = localStorage.getItem("oadaSettings");
  if (settingsRaw) {
    oadaSettings = JSON.parse(settingsRaw);
  }

  // configure variables based on Booking record type vs Projecttaskassign record type
  const recordType = oadaSettings.ganttSource || "Booking";
  const taskFieldName =
    recordType == "Booking" ? "project_taskid" : "projecttaskid";
  const unitFieldName = recordType == "Booking" ? "percentage" : "allocation";
  const hoursFieldName = recordType == "Booking" ? "hours" : "planned_hours";

  let tempArray = [];
  const origTaskArray = useRef();

  const handleWaitLocally = (value) => {
    setWait(value);
  };

  const getPredecessorString = (taskRecord) => {
    // format: XTT+Yunits, X = pred task ID, TT = type, Y = lag, units = lag type
    const preds = taskRecord.predecessors;
    const predLag = taskRecord.predecessors_lag;
    const predType = taskRecord.predecessors_type;

    if (preds.length > 0) {
      let predString = "";
      const predsArray = preds.split(",");
      let lagAmount = "";
      if (predLag.length > 0) {
        const predLagArray = predLag.split(",");

        predsArray.forEach((pred) => {
          predString = predString == "" ? pred : predString + "," + pred;
          predString += "FS";
          predLagArray.forEach((lag) => {
            if (lag.indexOf(pred + ":") == 0) {
              lagAmount = lag.substring(lag.indexOf(":") + 1) + "days";
              predString += "+" + lagAmount;
            }
          });
        });
      }
      return predString;
    } else {
      return "";
    }
  };
  // triggers on change in refreshFlag variable
  useEffect(() => {
    handleWaitLocally(true);
    resourceArray.current = [];

    // ensure project group local storage table is populated
    const globalDataObject = new GlobalData(creds);
    globalDataObject.populateTable("Projectgroup").then(() => {
      const projectGroups = JSON.parse(
        localStorage.getItem(creds.company + "|Projectgroup"),
      );

      // read all tasks from the project
      const requestString =
        authString +
        '<Read type="Projecttask" limit="1000" method="equal to" enable_custom="1" order="id_number"><Projecttask><projectid>' +
        projectObject.id +
        "</projectid></Projecttask></Read></request>";

      Tools.fetchPost(requestString, urlString, "Projecttask").then((val) => {
        let recordArray = [];
        for (let i = 0; i < val.xml.length; i++) {
          let recordObject = {};
          for (const entry of val.xml[i].childNodes.entries()) {
            const fieldName = entry[1].nodeName;
            const node = val.xml[i].childNodes[entry[0]];

            // Check if this is a Date node with nested year/month/day structure
            let fieldValue;
            if (
              node.childNodes.length > 0 &&
              node.querySelector("year, month, day")
            ) {
              // Parse nested date structure to MMddyyyy format
              const year = node.querySelector("year")?.textContent || "";
              const month = node.querySelector("month")?.textContent || "";
              const day = node.querySelector("day")?.textContent || "";

              if (year && month && day) {
                // Format as MMddyyyy (pad month and day with leading zeros if needed)
                fieldValue =
                  month.padStart(2, "0") + day.padStart(2, "0") + year;
              } else {
                fieldValue = node.textContent;
              }
            } else {
              fieldValue = node.textContent;
            }

            recordObject = { ...recordObject, [fieldName]: fieldValue };
          }
          recordArray.push(recordObject);
          // at this point recordArray is an array of recordObjects, which are name-value pairs for each field on the record, in this case Projecttask records
        }

        let personnelLookupString = "";
        for (let j = 0; j < recordArray.length; j++) {
          // determine start/end dates
          let start;
          let end;
          let startFixed = false;
          let endFixed = false;

          // set this to false if you want to attempt to use dependencies as intended
          /*let manualCalc =
            recordType == "Booking" &&
            oadaSettings.ganttDateSource == "bookings"
              ? true
              : false;*/

          if (recordArray[j].starts == "00000000") {
            start = recordArray[j].calculated_starts;
          } else {
            start = recordArray[j].starts;
            //manualCalc = true;
            startFixed = true;
          }
          if (recordArray[j].fnlt_date == "00000000") {
            end = recordArray[j].calculated_finishes;
          } else {
            end = recordArray[j].fnlt_date;
            //manualCalc = true;
            endFixed = true;
          }

          /*if (recordArray[j].is_a_phase == "1") {
            if (recordType == "Booking") {
              manualCalc = true; // used to be false
            } else {
              manualCalc = false;
            }
          }*/
          const baseStart = recordArray[j].oada_baseline_start__c;
          const baseEnd = recordArray[j].oada_baseline_end__c;

          //          const predecessorTypeColonIndex =
          //            recordArray[j].predecessors_type.indexOf(":");

          const startDateJS = new Date(
            start.substring(4, 8) +
              "-" +
              start.substring(0, 2) +
              "-" +
              start.substring(2, 4),
          );
          const endDateJS = new Date(
            end.substring(4, 8) +
              "-" +
              end.substring(0, 2) +
              "-" +
              end.substring(2, 4),
          );
          //dates *appear* to be 4-5 hours behind at this point re: CDT/CST
          startDateJS.setTime(
            startDateJS.getTime() + startDateJS.getTimezoneOffset() * 60000,
          );
          endDateJS.setTime(
            endDateJS.getTime() + endDateJS.getTimezoneOffset() * 60001, // 60001 will shift a task that ends on a weekend to the following Monday
          );

          /*const duration = Math.round(
            (endDateJS - startDateJS) / (1000 * 60 * 60 * 24),
          );*/
          let duration = 0;

          for (
            let durLoop = startDateJS.getTime();
            durLoop <= endDateJS.getTime();
            durLoop += 1000 * 60 * 60 * 24
          ) {
            const loopDate = new Date(durLoop);
            if (loopDate.getDay() > 0 && loopDate.getDay() < 6) {
              duration++;
            }
          }

          const predecessorString = getPredecessorString(recordArray[j]);

          // dates are accurate now, but only in current time zone (CDT/CST in dev)
          let task = {
            TaskID: parseInt(recordArray[j].id),
            TaskName: recordArray[j].name,
            ChangeLog: recordArray[j].oada_task_change_log__c,
            Duration: duration,
            Work: parseFloat(recordArray[j].planned_hours),
            StartDate: startDateJS,
            EndDate: endDateJS,
            StartFixed: startFixed,
            EndFixed: endFixed,
            //Manual: manualCalc,
            Manual: false,
            IsAPhase: recordArray[j].is_a_phase,
            BaselineStartDate: baseStart,
            BaselineEndDate: baseEnd,
            Progress: parseInt(recordArray[j].percent_complete || 0),
            Notes: recordArray[j].notes,
            //TaskType: "FixedWork",

            /*
          
          This type of logic is needed to process other typs of predecessors besides Finish-to-start
          
          Predecessor: recordArray[j].predecessors_type
            ? recordArray[j].predecessors_type.substring(
                0,
                predecessorTypeColonIndex,
              ) +
              recordArray[j].predecessors_type.substring(
                predecessorTypeColonIndex + 1,
              )
            : recordArray[j].predecessors,*/
            Predecessor: predecessorString,
            resources: [],
            CurrentUserAssigned: false,
            Assignees: recordArray[j].oada_assignees__c,
          };

          if (recordArray[j].parentid) {
            task = {
              ...task,
              ParentID: parseInt(recordArray[j].parentid),
            };
          }
          tempArray.push(task);

          // read either Projecttaskassign or Bookings records
          personnelLookupString +=
            '<Read type="' +
            recordType +
            '" limit="1000" method="equal to"><' +
            recordType +
            "><" +
            taskFieldName +
            ">" +
            recordArray[j].id +
            "</" +
            taskFieldName +
            "></" +
            recordType +
            "></Read>";
        }

        const assignmentRequestString =
          authString + personnelLookupString + "</request>";
        const globalDataObject = new GlobalData(creds);
        globalDataObject.populateTable("User" /*, true*/).then(() => {
          Tools.fetchPost(assignmentRequestString, urlString, recordType).then(
            (assignVal) => {
              const userNames = JSON.parse(
                localStorage.getItem(creds.company + "|User"),
              );

              // loop through all of the task's associated Projecttaskassign or Booking records
              for (let x = 0; x < assignVal.xml.length; x++) {
                let assignmentRecordObject = {};
                for (const entry of assignVal.xml[x].childNodes.entries()) {
                  const fieldName = entry[1].nodeName;
                  const node = assignVal.xml[x].childNodes[entry[0]];

                  // Check if this is a Date node with nested year/month/day structure
                  let fieldValue;
                  if (
                    node.childNodes.length > 0 &&
                    node.querySelector("year, month, day")
                  ) {
                    // Parse nested date structure to MMddyyyy format
                    const year = node.querySelector("year")?.textContent || "";
                    const month =
                      node.querySelector("month")?.textContent || "";
                    const day = node.querySelector("day")?.textContent || "";

                    if (year && month && day) {
                      // Format as MMddyyyy (pad month and day with leading zeros if needed)
                      fieldValue =
                        month.padStart(2, "0") + day.padStart(2, "0") + year;
                    } else {
                      fieldValue = node.textContent;
                    }
                  } else {
                    fieldValue = node.textContent;
                  }

                  assignmentRecordObject = {
                    ...assignmentRecordObject,
                    [fieldName]: fieldValue,
                  };
                }

                // assignmentRecordObject is a single Projecttaskassign or Booking record
                const taskToAssign = tempArray.find(
                  ({ TaskID }) =>
                    assignmentRecordObject[taskFieldName] == TaskID,
                );

                let resourceLookup = parseInt(assignmentRecordObject.userid);
                if (taskToAssign && creds.id == resourceLookup) {
                  taskToAssign.CurrentUserAssigned = true;
                }
                let belongsToProjectGroup = false;
                if (
                  assignmentRecordObject.project_groupid &&
                  assignmentRecordObject.project_groupid != "0"
                ) {
                  belongsToProjectGroup = true;
                  resourceLookup = projectGroups.find(
                    (elem) => elem.id == assignmentRecordObject.project_groupid,
                  ).name;
                }
                let resourceExists = resourceArray.current.find(
                  ({ resourceId }) => resourceLookup == resourceId,
                );
                if (!resourceExists) {
                  resourceArray.current.push({
                    resourceId: resourceLookup,
                    resourceName: belongsToProjectGroup
                      ? resourceLookup
                      : Tools.switchNames(
                          userNames.find(
                            ({ id }) => id == assignmentRecordObject.userid,
                          ).name,
                          " ",
                        ),

                    resourceAssignments: [],
                  });
                  resourceExists =
                    resourceArray.current[resourceArray.current.length - 1];
                }
                let resourceAssignmentExists =
                  resourceExists.resourceAssignments.find(
                    (assignmentRecord) => {
                      assignmentRecord.id == assignmentRecordObject.id;
                    },
                  );

                if (!resourceAssignmentExists) {
                  resourceExists.resourceAssignments.push({
                    id: assignmentRecordObject.id,
                    taskid: taskToAssign.TaskID,
                    hours: assignmentRecordObject[hoursFieldName],
                  });
                }

                if (taskToAssign) {
                  // add to resources if not already there
                  if (
                    taskToAssign.resources.find(
                      (elem) => elem.resourceId == resourceLookup,
                    ) == undefined
                  ) {
                    const unitCalc =
                      Math.round(
                        parseFloat(assignmentRecordObject[unitFieldName]) * 100,
                      ) / 100;
                    if (!isNaN(unitCalc) && unitCalc > 0) {
                      taskToAssign.resources.push({
                        resourceId: resourceLookup,
                        Unit:
                          Math.round(
                            parseFloat(assignmentRecordObject[unitFieldName]) *
                              100,
                          ) / 100,
                        Hours: isNaN(
                          parseFloat(assignmentRecordObject[hoursFieldName]),
                        )
                          ? 0
                          : parseFloat(assignmentRecordObject[hoursFieldName]),
                      });
                    }
                  }
                  // startdate and enddate are MMddyyyy
                  if (oadaSettings.ganttDateSource == "bookings") {
                    const reformattedStartDate =
                      assignmentRecordObject.startdate.substring(4, 8) +
                      "-" +
                      assignmentRecordObject.startdate.substring(0, 2) +
                      "-" +
                      assignmentRecordObject.startdate.substring(2, 4);
                    const reformattedEndDate =
                      assignmentRecordObject.enddate.substring(4, 8) +
                      "-" +
                      assignmentRecordObject.enddate.substring(0, 2) +
                      "-" +
                      assignmentRecordObject.enddate.substring(2, 4);
                    const bookingStartDate = new Date(reformattedStartDate);
                    bookingStartDate.setTime(
                      bookingStartDate.getTime() +
                        bookingStartDate.getTimezoneOffset() * 60000,
                    );
                    const bookingEndDate = new Date(reformattedEndDate);
                    bookingEndDate.setTime(
                      bookingEndDate.getTime() +
                        bookingEndDate.getTimezoneOffset() * 60000,
                    );
                    if (!taskToAssign.BookingStartDate) {
                      taskToAssign.BookingStartDate = bookingStartDate;
                    } else if (
                      bookingStartDate < taskToAssign.BookingStartDate
                    ) {
                      taskToAssign.BookingStartDate = bookingStartDate;
                    }
                    if (!taskToAssign.BookingEndDate) {
                      taskToAssign.BookingEndDate = bookingEndDate;
                    } else if (bookingEndDate > taskToAssign.BookingEndDate) {
                      taskToAssign.BookingEndDate = bookingEndDate;
                    }
                  }
                }
              }

              // add project team members to the resource array (resourceId, resourceName) if they aren't there already
              // also add assigned but not booked users if the record type is bookings
              const teamArray = projectObject.oada_project_team__c.split(";");
              teamArray.pop();
              for (let t = 0; t < teamArray.length; t++) {
                const teamMemberInfo = teamArray[t].split("|");
                const teamMemberExists = resourceArray.current.find(
                  ({ resourceId }) => parseInt(teamMemberInfo[1]) == resourceId,
                );
                if (!teamMemberExists) {
                  resourceArray.current.push({
                    resourceId: parseInt(teamMemberInfo[1]),
                    resourceName:
                      /*  teamMemberInfo[0].substring(
                        teamMemberInfo[0].indexOf(" ") + 1,
                      ) +
                      ", " +
                      teamMemberInfo[0].substring(
                        0,
                        teamMemberInfo[0].indexOf(" "),
                      ),*/
                      Tools.switchNames(teamMemberInfo[0]),
                    resourceHours: 0,
                  });
                }
              }

              for (let a = 0; a < tempArray.length; a++) {
                if (tempArray[a].Assignees) {
                  const assigneeIdArray = tempArray[a].Assignees.split("|");
                  for (let aa = 0; aa < assigneeIdArray.length; aa++) {
                    const foundInResources = tempArray[a].resources.find(
                      (elem) =>
                        parseInt(elem.resourceId) ==
                        parseInt(assigneeIdArray[aa]),
                    );
                    if (!foundInResources) {
                      tempArray[a].resources.push({
                        resourceId: parseInt(assigneeIdArray[aa]),
                        Unit: 100,
                        Hours: 0,
                      });
                      if (assigneeIdArray[aa] == creds.id) {
                        tempArray[a].CurrentUserAssigned = true;
                      }
                    }

                    /*
                    const assignment = {
                      hours: "0",
                      id: "0",
                      taskid: parseInt(tempArray[a].TaskID),
                    };
                    const assigneeRecInResourceArray =
                      resourceArray.current.find(
                        (elem) =>
                          parseInt(elem.resourceId) ==
                          parseInt(assigneeIdArray[aa]),
                      );
                    if (assigneeRecInResourceArray) {
                      if (assigneeRecInResourceArray.resourceAssignments) {
                        const assigneeFound =
                          assigneeRecInResourceArray.resourceAssignments.find(
                            (resElem) =>
                              parseInt(resElem.taskid) ==
                              parseInt(tempArray[a].TaskID),
                          );
                        if (!assigneeFound) {
                          assigneeRecInResourceArray.resourceAssignments.push(
                            assignment,
                          );
                        }
                      } else {
                        assigneeRecInResourceArray.resourceAssignments = [
                          assignment,
                        ];
                      }
                    } else {
                      const newAssigneeRec = {
                        resourceId: parseInt(assigneeIdArray[aa]),
                        resourceName: userNames.find(
                          ({ id }) =>
                            parseInt(id) == parseInt(assigneeIdArray[aa]),
                        ).name,
                        resourceAssignments: [assignment],
                      };
                      resourceArray.current.push(newAssigneeRec);
                    }*/
                  }
                }
              }

              /*
              const userList = JSON.parse(
                localStorage.getItem(creds.company + "|User"),
              );
              const userRec = userList.find(
                ({ nickname }) => creds.username == nickname,
              );
              userFullName.current = userRec.name;
              */
              if (oadaSettings.ganttDateSource == "bookings") {
                tempArray.forEach((elem) => {
                  if (elem.BookingStartDate) {
                    elem.StartDate = elem.BookingStartDate;
                  }
                  if (elem.BookingEndDate) {
                    elem.EndDate = elem.BookingEndDate;
                  }
                });
              }

              // check for assigned resources with no bookings, add to resources
              /*if (recordType == "Booking") {
                console.log(tempArray);
                const taskAssignmentString =
                  authString +
                  '<Read type="Projecttaskassign" method="equal to" limit="1000"><Projecttaskassign><projectid>' +
                  projectObject.id +
                  "</projectid></Projecttaskassign></Read></request>";
                Tools.fetchPost(
                  taskAssignmentString,
                  urlString,
                  "Projecttaskassign",
                ).then((rawRecord) => {
                  if (rawRecord.xml.length > 0) {
                    const ptaAssignRecs = Tools.xmlToArray(rawRecord.xml);
                    ptaAssignRecs.forEach((ptaElem) => {
                      const tempRec = tempArray.find(
                        (elem) => elem.TaskID == ptaElem.projecttaskid,
                      );
                      if (tempRec) {
                        const resourceRec = tempRec.resources.find(
                          (resourceElem) =>
                            (resourceElem.resourceId = ptaElem.userid),
                        );
                        if (!resourceRec) {
                          tempRec.resources.push({
                            resourceId: ptaElem.userid,
                            Unit: 100,
                            HOurs: 0,
                          });
                        }
                      }
                    });
                  }
                  origTaskArray.current = JSON.parse(JSON.stringify(tempArray));
                  setTaskArray(tempArray);
                  handleWaitLocally(false);
                });
              } else {
                */
              origTaskArray.current = JSON.parse(JSON.stringify(tempArray));
              setTaskArray(tempArray);
              handleWaitLocally(false);
              //}
            },
          );
          //handleWaitLocally(false);
        });
      });
    });
  }, [refreshFlag]);

  const refreshFunction = () => {
    handleWaitLocally(true);
    setRefreshFlag(!refreshFlag);
  };

  const handleActionComplete = (event) => {
    if (
      event.action == "DialogEditing" ||
      event.action == "DrawConnectorLine" ||
      event.action == "CellEditing" ||
      event.action == "TaskbarEditing" ||
      event.action == "add" ||
      event.action == "delete" ||
      event.requestType == "indented" ||
      event.requestType == "outdented" ||
      event.requestType == "rowDropped"
    ) {
      let recordArray = [];
      if (event.action == "DialogEditing" || event.action == "CellEditing") {
        recordArray = event.modifiedRecords;
      } else if (
        event.action == "delete" ||
        event.requestType == "indented" ||
        event.requestType == "outdented" ||
        event.requestType == "rowDropped"
      ) {
        recordArray.push(event.data[0]);
      } else {
        recordArray.push(event.data);
      }
      /*
      const record =
        event.action == "DialogEditing" || event.action == "CellEditing"
          ? event.modifiedRecords[0]
          : event.action == "delete"
            ? event.data[0]
            : event.data;
            */
      for (
        let recordCount = 0;
        recordCount < recordArray.length;
        recordCount++
      ) {
        const record = recordArray[recordCount];

        const changeRecord = {
          id: record.TaskID,
          pct: record.Progress,
          start: record.StartDate.toISOString().substring(0, 10),
          end: record.EndDate.toISOString().substring(0, 10),
          work: record.Work,
          name: record.TaskName,
          parentid: record.ParentID,
          action: event.action,
          predecessor: record.Predecessor,
          resources:
            typeof record.resources == "string" ? record.resources : "",
          resourceInfo: record.ganttProperties.resourceInfo,
          isAPhase: record.childRecords.length > 0 ? 1 : "",
        };

        const matchingIdRecordIndex = changeArray.current.findIndex(
          (elem) => elem.id == changeRecord.id,
        );
        if (matchingIdRecordIndex != -1) {
          changeArray.current[matchingIdRecordIndex] = changeRecord;
        } else {
          changeArray.current.push(changeRecord);
        }
      }
    }
  };

  const commitChanges = () => {
    const authString = Tools.getXmlBodyAuthString(creds);
    const urlString = Tools.getInstanceUrl(creds);
    let requestString = authString;
    let triggerChange = false;
    const newName =
      creds.name.substring(creds.name.indexOf(",") + 2) +
      " " +
      creds.name.substring(0, creds.name.indexOf(","));

    for (let i = 0; i < changeArray.current.length; i++) {
      const origTaskRec = origTaskArray.current.find(
        (elem) => elem.TaskID == changeArray.current[i].id,
      );

      // for change log message
      let changeMessage;

      const dateTimeString =
        ":o:" +
        new Date().toDateString() +
        " at " +
        new Date().toLocaleTimeString("en-US", {
          timeZone: "America/New_York",
        }) +
        " ET||";

      // parse resources
      // orig array resources is an array of objects with three elements, resourceId, Unit, Hours

      if (
        changeArray.current[i].resourceInfo &&
        changeArray.current[i].isAPhase != 1
      ) {
        const modifiedResourceLines = [];

        const userNames = JSON.parse(
          localStorage.getItem(creds.company + "|User"),
        );

        // TODO: This needs to be able to process assignment groups
        if (origTaskRec) {
          for (let j = 0; j < origTaskRec.resources.length; j++) {
            let origName = userNames.find(
              (elem) => elem.id == origTaskRec.resources[j].resourceId,
            );
            if (!origName) {
              // must be an assignment group...
              const assignGroupsString = localStorage.getItem(
                creds.company + "|Projectgroup",
              );
              if (assignGroupsString) {
                const groupNames = JSON.parse(assignGroupsString);
                origName = groupNames.find(
                  (groupElem) =>
                    groupElem.name == origTaskRec.resources[j].resourceId,
                );
              }
            }
            const foundName = changeArray.current[i].resourceInfo.findIndex(
              (elem) => elem.resourceId == origName.id,
            );

            if (foundName === undefined) {
              // delete user assignment/booking
              modifiedResourceLines.push({
                ...origTaskRec.resources[j],
                modType: "D",
              });
            }
          }
        }

        for (let x = 0; x < changeArray.current[i].resourceInfo.length; x++) {
          let unit = changeArray.current[i].resourceInfo[x].Unit;

          const userInfo = userNames.find(
            (elem) =>
              elem.id == changeArray.current[i].resourceInfo[x].resourceId,
          );
          if (userInfo) {
            //else assignment group

            const resourceRecord = resourceArray.current.find(
              (elem) => parseInt(userInfo.id) == elem.resourceId,
            );

            const resourceAssignmentHours = resourceRecord.resourceAssignments
              ? resourceRecord.resourceAssignments.find(
                  (elem) => elem.taskid == changeArray.current[i].id,
                )
                ? parseFloat(
                    resourceRecord.resourceAssignments.find(
                      (elem) => elem.taskid == changeArray.current[i].id,
                    ).hours,
                  )
                : 0
              : 0;

            const resourceHoursUnrounded =
              parseFloat(origTaskRec.Work) > 0
                ? resourceAssignmentHours *
                  (parseFloat(changeArray.current[i].work) /
                    parseFloat(origTaskRec.Work))
                : parseFloat(changeArray.current[i].work) /
                  origTaskRec.resources.length;

            const resourceHours =
              Math.round(resourceHoursUnrounded * 100) / 100;

            const compareObject = {
              resourceId: parseInt(userInfo.id),
              Unit: unit,
              Hours: resourceHours,
            };
            let compareIndex = -1;
            if (origTaskRec) {
              compareIndex = origTaskRec.resources.findIndex(
                (elem) =>
                  elem.resourceId == compareObject.resourceId &&
                  elem.Unit == compareObject.Unit &&
                  elem.Hours == compareObject.Hours,
              );
            }
            if (compareIndex == -1) {
              // add/update assignment/booking
              let compareUserIndex = -1;
              if (origTaskRec) {
                compareUserIndex = origTaskRec.resources.findIndex(
                  (elem) => elem.resourceId == compareObject.resourceId,
                );
              }
              if (compareUserIndex == -1) {
                modifiedResourceLines.push({ ...compareObject, modType: "A" });
              } else {
                modifiedResourceLines.push({ ...compareObject, modType: "U" });
              }
            }
          }
        }

        if (modifiedResourceLines.length > 0) {
          let actionRequest = authString;
          let readRequest = authString;
          for (let k = 0; k < modifiedResourceLines.length; k++) {
            readRequest +=
              '<Read type="' +
              recordType +
              '" method="equal to" limit="1000"><' +
              recordType +
              "><" +
              taskFieldName +
              ">" +
              origTaskRec.TaskID +
              "</" +
              taskFieldName +
              "></" +
              recordType +
              "></Read>";
          }
          readRequest += "</request>";

          const changeCopy = JSON.parse(JSON.stringify(changeArray.current[i]));

          // retrieve ALL records of the given type (Projecttaskassign or Booking) for the task, regardless of user id
          Tools.fetchPost(readRequest, urlString, recordType).then(
            (rawRecordObject) => {
              const records = Tools.xmlToArray(rawRecordObject.xml);

              for (let a = 0; a < modifiedResourceLines.length; a++) {
                if (modifiedResourceLines[a].modType != "A") {
                  // delete records if D or U

                  records.forEach((rec) => {
                    if (rec.userid == modifiedResourceLines[a].resourceId) {
                      actionRequest +=
                        '<Delete type="' +
                        recordType +
                        '"><' +
                        recordType +
                        "><id>" +
                        rec.id +
                        "</id></" +
                        recordType +
                        "></Delete>";
                    }
                  });
                }

                if (modifiedResourceLines[a].modType != "D") {
                  // add record if A or U
                  actionRequest +=
                    '<Add type="' +
                    recordType +
                    '"><' +
                    recordType +
                    "><userid>" +
                    modifiedResourceLines[a].resourceId +
                    "</userid>";

                  if (recordType == "Booking") {
                    actionRequest +=
                      "<as_percentage>1</as_percentage><booking_typeid>" +
                      BOOKING_TYPE_FOR_NEW_BOOKINGS +
                      "</booking_typeid><projectid>" +
                      projectObject.id +
                      "</projectid><customerid>" +
                      projectObject.customerid +
                      "</customerid><project_taskid>" +
                      origTaskRec.TaskID +
                      "</project_taskid><startdate>" +
                      Tools.parseDateString(changeCopy.start) +
                      "</startdate><enddate>" +
                      Tools.parseDateString(changeCopy.end) +
                      "</enddate><percentage>" +
                      Math.round(modifiedResourceLines[a].Unit * 100) / 100 +
                      "</percentage></" +
                      recordType +
                      "></Add>";
                  } else {
                    actionRequest +=
                      "<projecttaskid>" +
                      origTaskRec.TaskID +
                      "</projecttaskid><allocation>" +
                      modifiedResourceLines[a].Unit +
                      "</allocation><planned_hours>" +
                      modifiedResourceLines[a].Hours +
                      "</planned_hours></" +
                      recordType +
                      "></Add>";
                  }
                }
              }
              actionRequest += "</request>";
              Tools.fetchPost(actionRequest, urlString);
            },
          );
        }
      }
      // parse predecessors
      const predIdArray = [];
      if (changeArray.current[i].predecessor) {
        const regexDigits = new RegExp("^\\d+");
        const predArray = changeArray.current[i].predecessor.split(",");

        for (let z = 0; z < predArray.length; z++) {
          predIdArray.push(regexDigits.exec(predArray[z])[0]);
        }
      }

      // add new task
      if (origTaskRec == undefined) {
        changeMessage =
          new Date().getTime() +
          "|" +
          newName +
          ":c:CREATED:f::t:" +
          dateTimeString;
        requestString +=
          '<Add type="Projecttask" enable_custom="1"><Projecttask><projectid>' +
          projectObject.id +
          "</projectid><name>" +
          changeArray.current[i].name +
          "</name><predecessors>" +
          predIdArray.join() +
          "</predecessors><planned_hours>" +
          Math.round(changeArray.current[i].work * 100) / 100 +
          "</planned_hours><percent_complete>" +
          changeArray.current[i].pct +
          "</percent_complete><starts>" +
          Tools.parseDateString(changeArray.current[i].start) +
          "</starts><fnlt_date>" +
          Tools.parseDateString(changeArray.current[i].end) +
          "</fnlt_date><is_a_phase>" +
          changeArray.current[i].isAPhase +
          "</is_a_phase><oada_task_change_log__c>" +
          changeMessage +
          "</oada_task_change_log__c>";
        if (changeArray.current[i].parentid) {
          requestString +=
            "<parentid>" + changeArray.current[i].parentid + "</parentid>";
        }
        requestString += "</Projecttask></Add>";
        triggerChange = true;
      } else if (changeArray.current[i].action == "delete") {
        // no point in having a change message at the moment, maybe later
        changeMessage =
          new Date().getTime() + "|Deleted by " + newName + dateTimeString;
        requestString +=
          '<Delete type="Projecttask"><Projecttask><id>' +
          changeArray.current[i].id +
          "</id></Projecttask></Delete>";

        triggerChange = true;
      } else {
        // caps logs at 100 due to OA's text area limitation of 65K
        const origChangeLogFirst100Array = origTaskRec.ChangeLog.split("||");
        const origArrayLength = origChangeLogFirst100Array.length;
        const startingElement =
          origArrayLength > 100 ? origArrayLength - 100 : 0;
        const origChangeLogFirst100 =
          origChangeLogFirst100Array.slice(startingElement, 99).join("||") +
          "||";

        const timestamp =
          origChangeLogFirst100 + "\n" + new Date().getTime() + "|";
        changeMessage = "";

        requestString +=
          '<Modify type="Projecttask" enable_custom="1"><Projecttask><id>' +
          changeArray.current[i].id +
          "</id>";

        // planned hours changed
        if (
          parseFloat(changeArray.current[i].work) !=
          parseFloat(origTaskRec.Work)
        ) {
          requestString +=
            "<planned_hours>" +
            Math.round(changeArray.current[i].work * 100) / 100 +
            "</planned_hours>";
          changeMessage +=
            timestamp +
            newName +
            ":c:Planned Hours:f:" +
            Math.round(origTaskRec.Work * 100) / 100 +
            ":t:" +
            Math.round(changeArray.current[i].work * 100) / 100 +
            dateTimeString +
            "\n";
          triggerChange = true;
        }

        // % complete changed
        if (
          changeArray.current[i].pct != origTaskRec.Progress &&
          sessionStorage.getItem("pctCompleteReadOnly") == "false"
        ) {
          requestString +=
            "<percent_complete>" +
            changeArray.current[i].pct +
            "</percent_complete>";
          changeMessage +=
            timestamp +
            newName +
            ":c:Percent Complete:f:" +
            origTaskRec.Progress +
            ":t:" +
            changeArray.current[i].pct +
            dateTimeString +
            "\n";
          triggerChange = true;
        }

        // predecessor changed
        if (predIdArray.join() != origTaskRec.Predecessor) {
          requestString +=
            "<predecessors>" + predIdArray.join() + "</predecessors>";
          changeMessage +=
            timestamp +
            newName +
            ":c:predecessors:f:" +
            origTaskRec.Predecessor +
            ":t:" +
            predIdArray.join() +
            dateTimeString +
            "\n";
          triggerChange = true;
        }

        // startdate changed
        if (
          changeArray.current[i].start !=
            origTaskRec.StartDate.substring(0, 10) &&
          oadaSettings.ganttDateEditing &&
          origTaskRec.StartFixed &&
          origTaskRec.IsAPhase != "1"
        ) {
          requestString +=
            "<starts>" +
            Tools.parseDateString(changeArray.current[i].start) +
            "</starts>";
          changeMessage +=
            timestamp +
            newName +
            ":c:start date:f:" +
            origTaskRec.StartDate.substring(0, 10) +
            ":t:" +
            changeArray.current[i].start +
            dateTimeString +
            "\n";
          triggerChange = true;
        }

        // enddate changed
        if (
          changeArray.current[i].end != origTaskRec.EndDate.substring(0, 10) &&
          oadaSettings.ganttDateEditing &&
          origTaskRec.EndFixed &&
          origTaskRec.IsAPhase != "1"
        ) {
          requestString +=
            "<fnlt_date>" +
            Tools.parseDateString(changeArray.current[i].end) +
            "</fnlt_date>";
          changeMessage +=
            timestamp +
            newName +
            ":c:end date:f:" +
            origTaskRec.EndDate.substring(0, 10) +
            ":t:" +
            changeArray.current[i].end +
            dateTimeString +
            "\n";
          triggerChange = true;
        }

        // name changed
        if (changeArray.current[i].name != origTaskRec.TaskName) {
          requestString += "<name>" + changeArray.current[i].name + "</name>";
          changeMessage +=
            timestamp +
            newName +
            ":c:Name:f:'" +
            origTaskRec.TaskName +
            "':t:'" +
            changeArray.current[i].name +
            "'" +
            dateTimeString +
            "\n";
          triggerChange = true;
        }
        // parent changed
        if (changeArray.current[i].parentid != origTaskRec.ParentID) {
          requestString +=
            "<parentid>" + changeArray.current[i].parentid + "</parentid>";
          changeMessage +=
            timestamp +
            newName +
            ":c:Parent ID:f:" +
            origTaskRec.ParentID +
            ":t:" +
            changeArray.current[i].parentid +
            dateTimeString +
            "\n";
          triggerChange = true;
        }

        requestString +=
          "<oada_task_change_log__c>" +
          changeMessage +
          "</oada_task_change_log__c></Projecttask></Modify>";
      }
    }
    requestString += "</request>";
    changeArray.current.splice(0, changeArray.current.length); // clears the array

    if (triggerChange) {
      handleWaitLocally(true);
      Tools.fetchPost(requestString, urlString).then(() => refreshFunction());
    }
  };

  function saveBaseline() {
    handleWaitLocally(true);
    let baselineUpdateString = authString;
    taskArray.forEach((taskRecord) => {
      const bStart = Tools.unpackDate(
        Tools.parseDateObject(taskRecord.StartDate),
      );
      const bEnd = Tools.unpackDate(Tools.parseDateObject(taskRecord.EndDate));
      baselineUpdateString +=
        '<Modify type="Projecttask" enable_custom="1"><Projecttask><id>' +
        taskRecord.TaskID +
        "</id><oada_baseline_start__c>" +
        bStart +
        "</oada_baseline_start__c><oada_baseline_end__c>" +
        bEnd +
        "</oada_baseline_end__c></Projecttask></Modify>";
    });
    baselineUpdateString += "</request>";

    Tools.fetchPost(baselineUpdateString, urlString).then(() => {
      refreshFunction();
    });
  }
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: 999 }} //, zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={wait}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <GanttChartComponent
        tasks={taskArray}
        resources={resourceArray.current}
        //userFullName={userFullName.current}
        handleRefresh={refreshFunction}
        projectObject={projectObject}
        handleActionComplete={handleActionComplete}
        commitChanges={commitChanges}
        waitHandler={handleWaitLocally}
        waitValue={wait}
        saveBaseline={saveBaseline}
      />
    </>
  );
}

export default GanttChartContainer;

GanttChartContainer.propTypes = {
  waitHandler: PropTypes.func,
};
